import { AddUserHoldingViewCommand } from "@foodi/core"
import {
  AccountActions,
  PreferredZonesThunks,
  FiltersActions,
  HoldingThunks,
  HoldingAdditionErrors,
  BadgeLayouts,
} from "@modules"
import { ForceInfoAppUpdateActions, GlobalState, LoaderActions } from "@redux"
import { useDispatch, useSelector } from "react-redux"
import { getApolloClient } from "../apollo"
import * as Sentry from "@sentry/react"
import { displayToastSuccess } from "@utils"
import { I18n } from "react-redux-i18n"

const useBadgeManagement = () => {
  const dispatch = useDispatch()
  const userInfo = useSelector((state: GlobalState) => state.auth.userInfo)
  const { selectedHolding, isEditionMode, editionHoldingView } = useSelector(
    (state: GlobalState) => state.account
  )

  const reset = async () => {
    await dispatch(AccountActions.resetState())
    await dispatch(ForceInfoAppUpdateActions.setForceAppUpdate(true))
    await dispatch(PreferredZonesThunks.resetPreferredZonesStore())
    await dispatch(FiltersActions.resetState())
    await getApolloClient().cache.reset()
    await dispatch(ForceInfoAppUpdateActions.setForceAppUpdate(true))
  }

  const sendBadge = async (
    data: AddUserHoldingViewCommand,
    module: BadgeLayouts,
    skipped = false
  ) => {
    await dispatch(LoaderActions.setLoading(true))

    try {
      if (isEditionMode) {
        await dispatch(
          HoldingThunks.updateUserHoldingView({
            ...data,
            idHoldingView: editionHoldingView?.id,
          })
        )
      } else {
        //@ts-ignore
        const { id } = await dispatch(HoldingThunks.addUserHoldingView(data))
        await dispatch(
          HoldingThunks.switchUserHoldingView({ idHoldingView: id })
        )
      }

      displayToastSuccess(dispatch, I18n.t("associationBadge.successAddition"))
      await dispatch(AccountActions.setSuccessfullyAddedHolding(true))
    } catch (error) {
      //@ts-ignore
      const msg = error?.cause?.error?.message

      if (!(msg in HoldingAdditionErrors)) {
        throw msg
      }

      Sentry.captureException(error, {
        level: "error",
        extra: {
          module,
          description: `Error adding holding view for holding ID: ${selectedHolding?.id}, skipped: ${skipped}`,
          userId: userInfo?.id || "unknown",
          operation: isEditionMode
            ? "updateUserHoldingView"
            : "addUserHoldingView",
        },
        tags: {
          badgeManagement: "error",
        },
      })

      throw error
    } finally {
      await dispatch(LoaderActions.setLoading(false))
    }
  }

  return { reset, sendBadge }
}

export default useBadgeManagement
